window.Dialog = function() {
    var el = this;
    
    var isMoving = false;
    var movingElement = false;
    var elsList = {};
    var $currentDialog = false;
    
    el.init = function() {
        var offset = {top: 0, left: 0};
        var element = document.getElementById('workarea');
        if (element === null) {
            return;
        }

        var pos = element.getBoundingClientRect();
        var fixOffset = 50;

        offset.top += pos.top + $(window).scrollTop();

        if (pos.right + fixOffset + $currentDialog.width() < $(window).width()) {
            offset.left = pos.right + 50;
        } else {
            offset.left = pos.left - 50 - $currentDialog.width();
        }
        
        if (offset.left < 0) {
            offset.top = pos.top + $(window).scrollTop();
            offset.left = pos.left + (pos.width - $currentDialog.width()) / 2;
        }

        $currentDialog.removeClass('hide').offset(offset);
    };
    
    el.show = function (name, cb) {
        if (!$currentDialog) {
            $currentDialog = $('#' + name);
            el.init();
        }
    };

    el.beginMove = function () {
        movingElement = $currentDialog[0];
        isMoving = true;
        el._parent.isTransforming = true;
        
        elsList = {
            lastX: 0,
            lastY: 0
        };
    };

    el.move = function (event) {
        if (isMoving) {
            var movementX = 0;
            var movementY = 0;
            
            if (event.originalEvent.touches !== undefined) {
                event.preventDefault();
                movementX = elsList.lastX === 0 ? 0 : event.originalEvent.touches[0].pageX - elsList.lastX;
                movementY = elsList.lastY === 0 ? 0 : event.originalEvent.touches[0].pageY - elsList.lastY;
                elsList.lastX = event.originalEvent.touches[0].pageX;
                elsList.lastY = event.originalEvent.touches[0].pageY;
            } else {
                movementX = elsList.lastX === 0 ? 0 : event.clientX - elsList.lastX;
                movementY = elsList.lastY === 0 ? 0 : event.clientY - elsList.lastY;
                elsList.lastX = event.clientX;
                elsList.lastY = event.clientY;
            }
            
            var pos = movingElement.getBoundingClientRect();

            if (pos.right + movementX < $(window).width() && pos.left + movementX > 0) {
                movingElement.style.left = pos.left + movementX + 'px';
            }

            //if (pos.bottom + movementY < $(window).height() && pos.top + movementY > 0) {
                movingElement.style.top = pos.top + movementY + $(window).scrollTop() + 'px';
            //}
        }
    };

    el.endMove = function () {
        isMoving = false;
    };

    el.hide = function () {
        if ($currentDialog) {
            $currentDialog.addClass('hide');
            $currentDialog = false;
        }
    };
    
    $('.js-dialog-move').on('mousedown touchstart', el.beginMove);
    $(document).on('click', '.js-dialog-hide', function() {el.hide();});
};